import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Switch,
  FormControlLabel,
  Divider,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Brightness4 as DarkModeIcon,
  Brightness7 as LightModeIcon,
  AccountCircle as AccountIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { toggleTheme } from '../redux/slices/userSlice';
import { logout } from '../redux/slices/authSlice';
import { logoutUser } from '../services/authService';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentUser, theme } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    const titles = {
      '/': 'Dashboard',
      '/tvs': 'TV Management',
      '/media': 'Media Library',
      '/menus': 'Menu Builder',
      '/settings': 'Settings',
    };
    return titles[path] || 'DigiSlides';
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleThemeToggle = () => {
    dispatch(toggleTheme());
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
      dispatch(logout());
      handleMenuClose();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <AppBar position="fixed" elevation={0} sx={{ backgroundColor: 'background.paper', color: 'text.primary', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          {/* <Box
            component="img"
            src="/logo.png"
            alt="DigiSlides"
            sx={{ height: 32, mr: 2, display: { xs: 'none', sm: 'block' } }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          /> */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginLeft: `240px` }}>
            {/* <Typography 
              variant="h6" 
              fontWeight={700} 
              color="primary"
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              DigiSlides
            </Typography> */}
            {/* <Box
              sx={{
                height: 24,
                width: 1,
                bgcolor: 'divider',
                display: { xs: 'none', sm: 'block' },
              }}
            /> */}
            <Typography 
              variant="h6" 
              fontWeight={600}
              sx={{ 
                color: 'text.primary',
                fontSize: { xs: '1rem', sm: '1.25rem' },
              }}
            >
              {getPageTitle()}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* <IconButton onClick={handleThemeToggle} color="inherit">
            {theme === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton> */}

          <IconButton onClick={handleProfileMenuOpen} color="inherit">
            {currentUser ? (
              <Avatar sx={{ width: 32, height: 32 }}>
                {currentUser.name?.charAt(0) || 'U'}
              </Avatar>
            ) : (
              <AccountIcon />
            )}
          </IconButton>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {/* <MenuItem disabled>
            <Typography variant="body2" fontWeight={600}>
              {currentUser?.name || 'Mahmoud Digi'}
            </Typography>
          </MenuItem>
          <MenuItem disabled>
            <Typography variant="caption" color="text.secondary">
              {currentUser?.email || 'user@digislides.com'}
            </Typography>
          </MenuItem>
          <Divider /> */}
          {/* <MenuItem>
            <FormControlLabel
              control={<Switch checked={theme === 'dark'} onChange={handleThemeToggle} />}
              label="Dark Mode"
            />
          </MenuItem> */}
          {/* <MenuItem onClick={handleMenuClose}>Settings</MenuItem> */}
          {/* <Divider /> */}
          <MenuItem onClick={handleLogout}>
            <LogoutIcon sx={{ mr: 1, fontSize: 20 }} />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

